// extracted by mini-css-extract-plugin
export var box = "_9u-1";
export var checkboxRow = "_9u-8";
export var checked = "_9u-2";
export var descriptionSpacer = "_9u-a";
export var disabled = "_9u-3";
export var icon = "_9u-6";
export var input = "_9u-0";
export var labelSpacer = "_9u-9";
export var medium = "_9u-5";
export var small = "_9u-4";
export var text = "_9u-7";